'use client';

import { Text, TextLevels, TextMarkup, TypographyBold } from '@bytel/trilogy-react';

export type DasProps = {
    das: { name: string; value: string }[];
};

export function Das({ das }: Readonly<DasProps>) {
    return (
        <div>
            {das.map(({ name, value }) => (
                <Text marginless key={name} level={TextLevels.THREE}>
                    <Text markup={TextMarkup.SPAN}>{`DAS ${name}: `}</Text>
                    <Text markup={TextMarkup.SPAN} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                        {`${value} W/kg`}
                    </Text>
                </Text>
            ))}
        </div>
    );
}
